define('views/components/manual_payment_transaction/manual_payment_transactions',['require','views/base/collection_view','views/components/manual_payment_transaction/manual_payment_transaction_list','text!templates/components/manual_payment_transaction/manual_payment_transactions.html'],function(require){

    var BaseCollectionView = require('views/base/collection_view');
    var ListView = require('views/components/manual_payment_transaction/manual_payment_transaction_list');

    var temp = require("text!templates/components/manual_payment_transaction/manual_payment_transactions.html");
    return BaseCollectionView.extend({
        template: _.template(temp),
        className: 'grid-container transaction-grid-container',

        onRender: function () {
            this.ListContainer.show(new ListView({
                collection: this.collection
            }));
        }
    });
});

